import * as React from 'react';
import { SVGProps } from 'react';
import { Size } from '../types';
interface Props extends SVGProps<SVGSVGElement> {
  size?: Size;
}
const SvgChecklist = (props: Props) => {
  const getSize = () => {
    if (props.size) {
      switch (props.size) {
        case 'small':
          return 20;

        case 'medium':
          return 24;

        case 'large':
          return 32;

        default:
          return null;
      }
    }
  };

  return (
    <svg
      width={getSize() || 33}
      height={getSize() || 32}
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 33 32"
      {...props}
    >
      <path
        d="M26.8.15H6A2.526 2.526 0 003.45 2.7v26.6A2.526 2.526 0 006 31.85h20.7a2.526 2.526 0 002.55-2.55V2.7c0-1.426-1.121-2.55-2.45-2.55zm1.35 29.15c0 .772-.678 1.45-1.45 1.45H6c-.772 0-1.45-.678-1.45-1.45V2.7c0-.772.678-1.45 1.45-1.45h20.7c.772 0 1.45.678 1.45 1.45v26.6z"
        stroke="currentColor"
        strokeWidth={0.1}
      />
      <path
        d="M14.9 7.05h8.9a.55.55 0 00.398-.152.55.55 0 00.152-.398.55.55 0 00-.152-.398.55.55 0 00-.398-.152h-8.9a.55.55 0 00-.398.152.55.55 0 00.04.798c.107.094.243.15.358.15zm0 2.9h10.8a.55.55 0 00.398-.152.55.55 0 00.152-.398.55.55 0 00-.152-.398.55.55 0 00-.398-.152H14.9a.55.55 0 00-.398.152.55.55 0 00.04.798c.107.094.243.15.358.15zM11.35 21.7h-4a.55.55 0 00-.398.152.55.55 0 00-.152.398v3.9c0 .161.054.3.152.398a.55.55 0 00.398.152h3.9a.55.55 0 00.398-.152.55.55 0 00.152-.398v-3.892a.39.39 0 00-.102-.406.521.521 0 00-.348-.152zm-.55 3.9H7.9v-2.9h2.9v2.9zm4.1-2.75h8.9a.55.55 0 00.398-.152.55.55 0 00.152-.398.55.55 0 00-.152-.398.55.55 0 00-.398-.152h-8.9a.55.55 0 00-.398.152.55.55 0 00.04.798c.107.094.243.15.358.15zm10.9 1.8H14.9a.55.55 0 00-.398.152.55.55 0 00-.152.398c0 .161.054.3.152.398a.55.55 0 00.398.152h10.8a.55.55 0 00.398-.152.55.55 0 00.152-.398c0-.154-.025-.291-.097-.392-.074-.103-.19-.158-.353-.158zM11.35 13.8h-4a.55.55 0 00-.398.152.55.55 0 00-.152.398v3.9c0 .161.054.3.152.398a.55.55 0 00.398.152h3.9a.55.55 0 00.398-.152.55.55 0 00.152-.398v-3.892a.389.389 0 00-.102-.406.521.521 0 00-.348-.152zm-.55 3.9H7.9v-2.9h2.9v2.9zm4.1-2.75h8.9a.55.55 0 00.398-.152.55.55 0 00.152-.398.55.55 0 00-.152-.398.55.55 0 00-.398-.152h-8.9a.55.55 0 00-.398.152.55.55 0 00.04.798c.107.094.243.15.358.15zm0 2.9h10.8a.55.55 0 00.398-.152.55.55 0 00.152-.398.55.55 0 00-.152-.398.55.55 0 00-.398-.152H14.9a.55.55 0 00-.398.152.55.55 0 00.04.798c.107.094.243.15.358.15zm-4.2-8.9v.95H7.8V8.77l.515.515.008.009.011.003a2.24 2.24 0 01.327.14.443.443 0 00.189.063h.002c.049 0 .128 0 .195-.013a.266.266 0 00.099-.038.12.12 0 00.052-.076l3.487-3.488a.533.533 0 000-.77.533.533 0 00-.77 0l-.786.785H8.85a.55.55 0 00-.397.152.55.55 0 00-.152.398c0 .161.054.3.152.398A.55.55 0 008.85 7h1.18L8.85 8.18 7.285 6.614a.533.533 0 00-.77 0 .533.533 0 000 .77l.285.286v2.779c0 .161.054.3.152.398A.55.55 0 007.35 11h3.9a.55.55 0 00.398-.152.55.55 0 00.152-.398v-1.5a.55.55 0 00-.152-.398.55.55 0 00-.398-.152.55.55 0 00-.398.152.55.55 0 00-.152.398z"
        stroke="currentColor"
        strokeWidth={0.1}
      />
    </svg>
  );
};

export default SvgChecklist;
